import React, { useEffect, useState } from "react"
import API from "@/common/API"
import moment from "moment"
import { useTranslation } from "react-i18next"
import { Card, Table, Badge, Button } from "react-bootstrap"

const VehicleVisit = (props: { id: string }) => {
  const [records, setRecords] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = 5
  const { t } = useTranslation()

  const fetchRecords = async () => {
    try {
      setLoading(true)
      const response = await API.getAction("placeVisit/VehicleVisits?placeId=" + props.id)
      if (response.data.status === "ok") {
        setRecords(response.data.response || [])
      }
    } catch (error) {
      console.error("Error fetching vehicle visits:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchRecords()
  }, [props.id])

  if (records.length === 0 && !loading) {
    return null
  }

  const totalPages = Math.ceil(records.length / pageSize)
  const currentRecords = records.slice((currentPage - 1) * pageSize, currentPage * pageSize)

  return (
    <Card className="shadow-sm border rounded-4 my-4 overflow-hidden">
      <Card.Header className="bg-white py-3 px-3 d-flex align-items-center justify-content-between border-bottom">
        <div className="d-flex align-items-center gap-2">
          <i className="fas fa-truck text-primary fs-5" />
          <h6 className="fw-bold mb-0 text-dark">{t("Visitas de Vehículos (GPS)")}</h6>
          <Badge bg="primary" pill className="ms-1">
            {records.length}
          </Badge>
        </div>
      </Card.Header>
      <Card.Body className="p-0">
        {loading ? (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-spinner fa-spin me-2" />
            {t("Cargando visitas de vehículos...")}
          </div>
        ) : (
          <Table responsive hover className="align-middle mb-0 small">
            <thead className="table-light">
              <tr>
                <th className="ps-3">{t("Fecha / Hora")}</th>
                <th>{t("Vehículo")}</th>
                <th className="pe-3 text-end">{t("Distancia (mts)")}</th>
              </tr>
            </thead>
            <tbody>
              {currentRecords.map((record: any, idx: number) => (
                <tr key={record.id || idx}>
                  <td className="ps-3 fw-semibold text-dark">
                    {moment(record.visitDate).format("DD/MM/YYYY HH:mm")}
                    <small className="text-muted d-block font-normal">({moment(record.visitDate).fromNow()})</small>
                  </td>
                  <td>
                    <Badge bg="light" text="dark" className="border px-2 py-1 rounded-pill">
                      <i className="fas fa-truck-pickup text-primary me-1" />
                      {record.vehicleName}
                    </Badge>
                  </td>
                  <td className="pe-3 text-end fw-bold text-secondary">
                    {Number(record.distance || 0).toFixed(2)} m
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
      {totalPages > 1 && (
        <Card.Footer className="bg-white py-2 px-3 d-flex align-items-center justify-content-between border-top">
          <small className="text-muted">
            Página {currentPage} de {totalPages} ({records.length} visitas)
          </small>
          <div className="d-flex gap-1">
            <Button
              variant="outline-secondary"
              size="sm"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
              className="py-1 px-2 rounded-pill"
            >
              <i className="fas fa-chevron-left" /> Anterior
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
              className="py-1 px-2 rounded-pill"
            >
              Siguiente <i className="fas fa-chevron-right" />
            </Button>
          </div>
        </Card.Footer>
      )}
    </Card>
  )
}

export default VehicleVisit